<template>
  <v-row class="align-end flex-wrap-reverse mt-5">
    <v-col cols="12" md="7" sm="12">
      <b-form hide-action-buttons :readonly="disabled">
        <v-row>
          <v-col cols="12" md="12" sm="12">
            <b-input
              v-model="protocol.name"
              :disabled="disabled"
              hide-details
              label="Назва протоколу"
              placeholder="Введіть текст"
              readonly>
            </b-input>
          </v-col>
          <v-col cols="12" md="6" sm="12">
            <b-input
              v-model="protocol.number"
              :disabled="disabled"
              hide-details
              label="Номер протоколу"
              placeholder="Введіть номер">
            </b-input>
          </v-col>
          <v-col cols="12" md="6" sm="12">
            <b-input-date
              v-model="protocol.date"
              :disabled="disabled"
              hide-details
              label="Дата протоколу"
              time-picker></b-input-date>
          </v-col>
          <v-col cols="12" md="12" sm="12">
            <b-server-autocomplete
              v-model="protocol.issuedUserId"
              :defaultItem="protocol.issuedUser"
              :item-title="
                u =>
                  `${u.surname ? getPersonName(u) : u?.name} ${
                    !u.isActive && u?.id ? '(Звільнений)' : ''
                  }`
              "
              :search-min-length="3"
              :url="urlAllUsers()"
              has-empty
              hide-details
              item-value="id"
              label="Підготовив"
              placeholder="Введіть мін. 3 символи">
            </b-server-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" sm="12">
            <b-select
              v-model="protocol.typeId"
              :items="$directory.get('protocolTypes', protocol.type)"
              :loading="$loading.isLoading('protocolTypes')"
              hide-details
              item-title="name"
              item-value="id"
              label="Тип"
              placeholder="Оберіть зі списку"
              @focus="$directory.fill('protocolTypes')">
            </b-select>
          </v-col>
          <v-col cols="12" md="6" sm="12">
            <b-select
              v-model="protocol.directionId"
              :items="$directory.get('protocolDirections', protocol.direction)"
              :loading="$loading.isLoading('protocolDirections')"
              hide-details
              item-title="name"
              item-value="id"
              label="Напрямок"
              placeholder="Оберіть зі списку"
              @focus="$directory.fill('protocolDirections')">
            </b-select>
          </v-col>
          <v-col cols="12" md="12" sm="12">
            <b-select
              v-model="protocol.departmentId"
              :items="$directory.get('departmentList', protocol.department)"
              :loading="$loading.isLoading('departmentList')"
              hide-details
              item-title="name"
              item-value="id"
              label="Департамент"
              placeholder="Оберіть зі списку"
              @focus="$directory.fill('departmentList')">
            </b-select>
          </v-col>
          <v-col cols="12" md="12" sm="12">
            <b-textarea
              v-model="protocol.description"
              :disabled="disabled"
              :rows="3"
              hide-details
              label="Опис протоколу"
              placeholder="Введіть текст"></b-textarea>
          </v-col>
          <v-col cols="12" md="12" sm="12">
            <span class="label">Примітки</span>
            <Notes :disabled="!protocol.isActive" />
          </v-col>
        </v-row>
      </b-form>
    </v-col>
    <v-col cols="12" md="5" sm="12">
      <div>
        <v-card variant="outlined" class="mb-3" style="border-color: #49a2f4">
          <v-card-text>
            <div class="mb-3">
              <b>Вкладення:</b>
            </div>

            <FilesUploader
              v-model="protocol.document"
              :accept="['.pdf']"
              :disabled="disabled"
              :name-folder="protocol.number"
              class="mb-3"
              file-list
              label="Файли протоколу"
              main-folder="Протоколи"
              noCard />
            <FilesUploader
              v-model="protocol.extraDocuments"
              :disabled="disabled"
              :name-folder="protocol.number"
              file-list
              label="Додаткові файли протоколу"
              main-folder="Протоколи"
              noCard
              @change="protocolUpdateExtraDocument" />
          </v-card-text>
        </v-card>
        <div class="d-flex mb-3">
          <div v-if="acknowledgmentAccess">
            <v-btn
              v-if="isAcknowledgmentAgreed"
              size="small"
              style="cursor: default; pointer-events: none">
              Ознайомлений
            </v-btn>
            <v-btn
              v-else
              label="Ознайомитись"
              size="small"
              @click="acknowledgmentAgree">
              Ознайомитись
            </v-btn>
          </div>
        </div>
        <div class="info">
          <div>
            <span>
              До ознайомлення:
              {{ acknowledgmentList?.length }} користувачів
            </span>
            <span>
              Прочитано:
              {{ acknowledgmentList.filter(u => u.isAccept).length }}
              користувачів
            </span>
          </div>
          <div>
            <span>
              Дата створення:
              {{ new CustomDate(protocol.created_at).toString({ time: true }) }}
            </span>
            <span>
              Дата оновлення:
              {{ new CustomDate(protocol.updated_at).toString({ time: true }) }}
            </span>
            <span>Автор: {{ getPersonName(protocol.author) }}</span>
          </div>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { navigateToItem } from '@/utils/helpers.js'
import FilesUploader from '@/components/filesUploader/FilesUploader.vue'
import Notes from '@/components/notes/Notes.vue'
import { getPersonName, CustomDate } from 'best-modules/utils'
import {
  BServerAutocomplete,
  BTextarea,
  BForm,
  BInputDate,
} from 'best-modules/components'
import { urlAllUsers } from '@/utils/urls.js'
import { useProtocol } from '../protocol'
import { useAcknowledgment } from '@/components/acknowledgment'

export default {
  components: {
    Notes,
    BInputDate,
    FilesUploader,
    BServerAutocomplete,
    BTextarea,
    BForm,
  },
  methods: { getPersonName, CustomDate },
  setup() {
    const { protocolUpdateExtraDocument, protocol, disabled } = useProtocol()
    const {
      acknowledgmentAccess,
      isAcknowledgmentAgreed,
      acknowledgmentAgree,
      acknowledgmentList,
    } = useAcknowledgment()

    return {
      protocolUpdateExtraDocument,
      protocol,
      navigateToItem,
      urlAllUsers,
      disabled,
      acknowledgmentAccess,
      isAcknowledgmentAgreed,
      acknowledgmentAgree,
      acknowledgmentList,
    }
  },
}
</script>

<style lang="scss" scoped>
.info {
  background: #f5f6f8;
  padding: 8px;
  display: flex;
  justify-content: space-between;

  span {
    display: block;
    font-size: 12px;
    color: #b5b7c0;
    margin-bottom: 4px;
  }
}
</style>
